import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent extends DialogContentBase {
  public form: FormGroup;
  public user: string;
  constructor(private formBuilder: FormBuilder, private dialogRef: DialogRef) {
    super(dialogRef);
    this.form = this.formBuilder.group({
      password: ['', [Validators.required]],
    });
  }

  public send(): void {
    if (!this.form.valid) {
      return;
    }
    this.closeDialog(this.form.getRawValue(), 'confirm');
  }

  public closeDialog(password?: string, action = 'cancel'): void {
    this.dialogRef.close({ text: action, password });
  }
}
